import type { CSSProperties } from 'react';
import { paulBrand } from '../../branding/paul';

export function PaulLoadingShell() {
  return (
    <div
      className="od-loading-shell"
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        background: '#ffffff',
        color: '#111111',
      }}
    >
      <img
        src={paulBrand.logoUrl}
        alt=""
        width={56}
        height={56}
        draggable={false}
        style={{
          display: 'block',
          width: 56,
          height: 56,
          animation: 'paul-loading-pulse 1.6s ease-in-out infinite',
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 5,
        }}
      >
        <span
          style={{
            font: '600 16px/1.2 var(--sans, system-ui, -apple-system, "Segoe UI", sans-serif)',
            color: '#111111',
            letterSpacing: '-0.01em',
          }}
        >
          {paulBrand.appName}
        </span>
        <span
          aria-hidden
          style={{
            display: 'inline-flex',
            gap: 4,
          }}
        >
          <i style={dotStyle(0)} />
          <i style={dotStyle(0.18)} />
          <i style={dotStyle(0.36)} />
        </span>
      </div>
      <style>{`
        @keyframes paul-loading-pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(0.96); opacity: 0.78; }
        }
        @keyframes paul-loading-dot {
          0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
          40% { opacity: 1; transform: translateY(-2px); }
        }
      `}</style>
    </div>
  );
}

function dotStyle(delay: number): CSSProperties {
  return {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: 'hsl(257 65% 57%)',
    animation: `paul-loading-dot 1.2s ${delay}s ease-in-out infinite`,
  };
}
